import { Outlet } from 'react-router-dom'

import { ContentPageLayout } from '@/layout/components/content-page-layout/ContentPageLayout'

export const CareQuestionRootPage = () => {
  return (
    <ContentPageLayout noPadding>
      <Outlet />
    </ContentPageLayout>
  )
}
